<glxy-form-field appearance="outline" *ngIf="opportunity$ | async as opportunity">
  <glxy-label>
    {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.EXPECTED_CLOSE' | translate }}
  </glxy-label>
  <mat-datepicker-toggle matSuffix [for]="expectedClosePicker"></mat-datepicker-toggle>
  <input
    matInput
    placeholder="{{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.EXPECTED_CLOSE' | translate }}"
    [matDatepicker]="expectedClosePicker"
    [readonly]="true"
    [value]="opportunity.expectedCloseDate"
    [min]="minDate"
    (dateChange)="handleExpectedCloseDateChange($event)"
  />
  <mat-datepicker #expectedClosePicker></mat-datepicker>
</glxy-form-field>
